<template>
  <span> </span>
</template>
<script>
export default {
  name: 'pdp-e-commerce-data',
  props: {
    dataLayerExtraParams: {
      type: Object,
      default: () => ({ no: 'datas' }),
    },
  },
  created() {
    window.refapp = {
      mctbEcommerce: this.dataLayerExtraParams,
    };
  },
};
</script>
